import styled, { css } from 'styled-components/macro';
import { boxShadow } from 'styles/base-classes';
import { ellipsis } from 'polished';

export const DropdownListWrapper = styled('div')<any>`
  ${boxShadow};
  background: white;
  display: block;
  position: absolute;
  z-index: 9999;
  margin: 0 !important;

  ${({ overflowLeft }): any =>
    overflowLeft &&
    css`
      right: 0;
    `};
`;

const DropdownList = styled('ul')<any>`
  max-height: 20em;
  overflow-y: ${({ smoothScrolling }): string =>
    smoothScrolling ? 'scroll' : 'auto'};
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;

  button,
  a:not(.defaultAnchor) {
    ${ellipsis('100%')};
    padding: ${({ theme }): string =>
      `${theme.spacing.xsmall} ${theme.spacing.medium}`};
    display: block;
    width: 100%;
    text-align: left;
    white-space: nowrap;
    color: ${({ theme }): string => theme.NightBlue};

    span {
      display: inline-block;
      transition: transform ${({ theme }): string => theme.transitionDuration};
      transition-timing-function: ${({ theme }): string =>
        theme.timingFunction};
    }

    &:hover,
    &:focus {
      background: ${({ theme }): string => theme.Sand};

      /* Disable for a false positive */
      /* stylelint-disable-next-line no-descending-specificity */
      span {
        transition: transform ${({ theme }): string => theme.transitionDuration};
        transition-timing-function: ${({ theme }): string =>
          theme.timingFunction};
        transform: translateX(5px);
      }
    }
    &:active {
      background: ${({ theme }): string => theme.LightGrey};
    }
  }

  &[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

/**
 * @component
 */
export default DropdownList;
